import { FieldValues, Path } from "react-hook-form";

import { FormMoneyInput } from "../../../components/Input";
import { CHARGE_FIELD_NAMES, CHARGE_LABELS } from "./constants";
import {
  Field,
  FieldHelper,
  FieldLabel,
  LabelRow,
} from "../../../components/FormPanel";
import { chargeRule } from "./tradeValidation";
import { ChargeFieldProps } from "./types";

// Shared across six near-identical call sites (buy/sell/correction × desktop/compact) to stop the
// label, validation and wording drifting between a panel and its compact twin.
export const ChargeField = <T extends FieldValues>({
  id,
  control,
  charge,
  helper,
  isSubmitting,
  taxedIncome,
}: ChargeFieldProps<T>) => (
  <Field>
    <LabelRow>
      <FieldLabel htmlFor={id}>{CHARGE_LABELS[charge]}</FieldLabel>
    </LabelRow>
    <FormMoneyInput
      id={id}
      name={CHARGE_FIELD_NAMES[charge] as Path<T>}
      control={control}
      rules={{ validate: chargeRule(charge, taxedIncome) }}
      disabled={isSubmitting}
      placeholder="0.00"
    />
    <FieldHelper>{helper}</FieldHelper>
  </Field>
);
